/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native-unistyles';
import { pd } from '@airasia-phoenix/react-native/tokens';
import { getColor } from '@airasia-phoenix/react-native/utils/utils';

export const styles = StyleSheet.create((pd) => ({
  // Desktop: card/tooltip variant
  desktopWrapper: {
    position: 'absolute',
    top: 33,
    right: -pd.ref.space.spacing40.px,
    zIndex: 11,
  },
  container: {
    width: 328,
    backgroundColor: getColor(pd.sys.colour.container_none),
    borderRadius: pd.ref.space.spacing40.px,
    borderWidth: 1,
    borderColor: getColor(pd.sys.colour.outline_low),
    justifyContent: 'center',
    alignItems: 'center',
    padding: pd.ref.space.spacing40.px,
  },
  contentWrapper: {
    alignItems: 'center',
    gap: pd.ref.space.spacing20.px,
  },
  infoTextWrapper: {
    width: 236,
  },
  infoTextParent: {
    textAlign: 'center',
  },
  infoText: {
    textAlign: 'center',
    maxWidth: '100%',
    overflow: 'hidden',
  },
  closeButton: {
    position: 'absolute',
    top: pd.ref.space.spacing40.px,
    left: pd.ref.space.spacing40.px,
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },

  // Mobile: inline banner variant
  mobileWrapper: {
    position: 'fixed' as any,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 11,
  },
  containerMobile: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: getColor(pd.sys.colour.container_none),
    padding: pd.ref.space.spacing40.px,
    gap: pd.ref.space.spacing20.px,
  },
  closeButtonMobile: {
    width: 24,
    height: 24,
    flexShrink: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  infoTextWrapperMobile: {
    flex: 1,
    minWidth: 0,
    flexWrap: 'wrap',
    maxWidth: `calc(100% - 140px)` as any,
  },
  infoTextMobile: {
    flex: 1,
    minWidth: 0,
    flexShrink: 1,
    flexWrap: 'wrap',
  },
  loginButtonWrapperMobile: {
    flexShrink: 0,
  },
}));
